module.exports = __webpack_public_path__ + "img/sophie_living_cover_img.ea560ece.jpg";